import BootstrapVue from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
window.axios = require('axios');
import VueAxios from './plugins/axios'
import { ModalPlugin } from 'bootstrap-vue'

import 'date-input-polyfill';

// Import vue
window.Vue = require('vue');
window.Vue.use(BootstrapVue);
// window.Vue.use(ModalPlugin)
window.Vue.use(VueAwesomeSwiper);
window.Vue.use(VueAxios);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


let currency = document.querySelector('[property=currency][content]').content;
let baseurl = document.querySelector('[property=baseurl][content]').content;
let cartCount = document.querySelector('[property=cartCount][content]').content;
let productCat = document.querySelector('[property=productCat][content]').content;
let productAttributes = document.querySelector('[property=productAttributes][content]').content;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page.
 */


const app = new Vue({
    el: '#app',
    data: {
        view: '',
        currency: currency,
        baseurl: baseurl,
        cartcount: parseInt(cartCount),
        show_voucher_form_email: false,
        show_voucher_form_post: false,
        productCat: productCat,
        productAttributes: JSON.parse(productAttributes),
        emptyFilters: true,
        nav_open: 'chuj ass'
    },
    methods: {
        openUrl: function(url) {
            window.location.href = url;
        },
        showPostVoucher: function() {
            this.show_voucher_form_post = true;
        },
        showVoucherEmail: function() {
            this.show_voucher_form_email = true;
        },
        closeModal: function(ref) {
            this.$refs[ref].hide();
        },
        openNav: function() {
            if ( this.nav_open.length == 0 )
                this.nav_open = 'is-active'
            else
                this.nav_open = ''
        },
        showNav: function() {
            return this.nav_open
        }
    },
    mounted() {
        this.$on('updateCartCount', data => {
            console.log(data)
            this.cartcount += parseInt(data);
        })
    }
});